import { createContext } from 'react';
import type { AdContextValue } from '../types';

export const AdDataContext = createContext<AdContextValue>({} as AdContextValue);
